module.exports = __webpack_public_path__ + "static/media/Bedroom4-1.ccab83d3.jpg";